import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';

// Contacts-grid cell: how many of the team's connections reach this contact
// (Figma "Connections" column, sits beside Reachability). A dash when there are
// none / the count is not yet emitted by the BE.
export const ConnectionsRenderer = ({ value }) => {
  const count = Number.isFinite(value) ? value : 0;
  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
      <Text fontSize="14px" color={count > 0 ? 'text.dark' : 'text.subtle'}>
        {count > 0 ? count.toLocaleString() : '—'}
      </Text>
    </Flex>
  );
};

ConnectionsRenderer.propTypes = {
  value: PropTypes.number,
};

ConnectionsRenderer.defaultProps = {
  value: null,
};
